import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

import { Subject } from 'rxjs';

// services
import { ErrorHandler } from './error-handler.service';

// path globals
import { API_PATH, SUBSCRIPTION_KEY, ADD_BOOKING_NOTE } from '../globals';


@Injectable({
  providedIn: 'root',
})
export class AddNoteService {

  private _token;

  public addNoteResponse$: Subject<any> = new Subject();

  constructor (
    private _http: HttpClient,
    private _errorService: ErrorHandler
  ) {}

  createAuthorizationHeader(headers: HttpHeaders, tokenFromCall?) {
    const userToken = typeof this._token === 'undefined' ? tokenFromCall : this._token;
    headers = headers.set('Authorization', 'bearer ' + userToken);
    return headers;  }


  addBookingNote(request: any, token) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);

    this._http.post(API_PATH + ADD_BOOKING_NOTE, request, {headers: headers})
      .subscribe(
        res => {
          this.addNoteResponse$.next(true);
        },
        err => {
          this.addNoteResponse$.next(false);
          this._errorService.handleError(err);
          return;
        });
  }

}
